export default () => (
  <svg
    width="7"
    height="4"
    viewBox="0 0 7 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.79289 4C6.23835 4 6.46143 3.46143 6.14645 3.14645L3.85355 0.853553C3.65829 0.658291 3.34171 0.658291 3.14645 0.853553L0.853553 3.14645C0.53857 3.46143 0.761654 4 1.20711 4L5.79289 4Z"
      fill="currentColor"
    />
  </svg>
);
